import React from 'react';
import PropTypes from 'prop-types';
var PermissionError = function PermissionError(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React.createElement("h1", {
    className: "text-center text-white-50"
  }, message);
};
PermissionError.propTypes = {
  message: PropTypes.string
};
PermissionError.defaultProps = {
  message: __('You do not have the permissions to access the content')
};
export default PermissionError;